import { useCallback } from 'react'
import { useTranslation as useI18nTranslation } from 'react-i18next'

export function useTranslations(namespace: string) {
  const { t } = useI18nTranslation()

  return useCallback((key: string, params?: Record<string, any>) => {
    return t(`${namespace}.${key}`, params)
  }, [namespace, t])
}

export function useLocale() {
  const { i18n } = useI18nTranslation()
  const baseLang = i18n.resolvedLanguage?.split('-')[0] || i18n.language.split('-')[0]
  if (baseLang === 'zh' || baseLang === 'en' || baseLang === 'ja' || baseLang === 'ko') {
    return baseLang
  }
  return 'zh'
}

export { useTranslation } from 'react-i18next'
